<template>
  <div
    ref="root"
    class="infoblock"
    :style="cssVariables"
  >
    <TheContent
      v-for="item of children"
      :key="item.id"
      :elem="item"
    />
  </div>
</template>

<script lang="ts" setup>
  import type { TContent } from '~/types/common';
  import TheContent from '~/components/TheContent';
  import { useSingleArticleStore } from '~/store/singleArticle';

  const props = defineProps<{
    elem: TContent;
  }>();

  const singleArticleStore = useSingleArticleStore();
  const children = computed(() => props.elem.children);
  const mainColor = computed(() => singleArticleStore.article?.meta?.main_color ?? '');
  const safeColor = computed(() => mainColor.value || '#C722CA');

  const cssVariables = computed(() => ({
    '--info-box-border-color': safeColor.value,
    '--base-button-background': safeColor.value,
    '--base-button-hover-background': `color-mix(in srgb, ${safeColor.value} 90%, black)`,
  }));
</script>

<style lang="scss" scoped>
  @use '~/scss/article' as *;

  .infoblock {
    width: 100%;
    padding: ($spacing-4 + $spacing-1) $spacing-4 $spacing-6;
    border-bottom: 1px solid $stroke-color--1;
    border-left: 1px solid $stroke-color--1;
    border-right: 1px solid $stroke-color--1;
    border-radius: 0 0 32px 32px;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 0;
      left: -1px;
      right: -1px;
      display: block;
      border-top: $spacing-1 solid var(--info-box-border-color);
    }

    :deep() > {
      @include article-elems;
    }
  }
</style>
